module.exports = __webpack_public_path__ + "static/media/filter-icon.e4d52b1f.svg";